import React from 'react';
import { motion } from 'framer-motion';
interface AnswerRecapProps {
  lead: string;
  value: string;
  /** Optional free-text the delegate added alongside their choice. */
  note?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function AnswerRecap({
  lead,
  value,
  note
}: AnswerRecapProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.24,
    ease: EASE
  }} className="rounded-xl border border-blue/40 bg-blue/[0.06] px-4 py-3.5" data-id="element-21" data-mp="3b3ouvguah4af">
      <p className="text-[9px] uppercase tracking-micro text-blue" data-id="element-22" data-mp="325ctqkvsqo3q">{lead}</p>
      <p className="mt-1.5 font-display text-[20px] font-semibold leading-tight tracking-tight text-navy" data-id="element-23" data-mp="2ng6zzcfq9q38">
        {value}
      </p>
      {note && <p className="mt-1.5 text-[12px] leading-snug text-navy2" data-id="element-24" data-mp="2sbw0bhzknb0l">“{note}”</p>}
    </motion.div>;
}